export enum SizingToolState {
  Open = 'OPEN',
  Closed = 'CLOSED',
  Complete = 'COMPLETE',
  ClosedWithoutModalClose = 'ClosedWithoutModalClose',
}

export enum ModalToggleState {
  Open = 'OPEN',
  Closed = 'CLOSED',
}

export enum DrawerToggleState {
  Open = 'OPEN',
  Closed = 'CLOSED',
}
